import { RouterProvider } from "react-router-dom";

import { ReactKeycloakProvider } from "@react-keycloak/web";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ConfigProvider } from "antd";

import { AppRouter } from "@app/AppRouter";
import { LanguageProvider } from "@app/components/language/LanguageProvider.tsx";
import { keycloakInstance } from "@app/keycloak/KeycloakConfig.ts";
import { theme } from "@app/theme.ts";

export const App = () => {
  const queryClient = new QueryClient();

  return (
    <ConfigProvider theme={theme}>
      <LanguageProvider>
        <ReactKeycloakProvider
          authClient={keycloakInstance}
          initOptions={{ checkLoginIframe: false }}
        >
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={AppRouter} />
          </QueryClientProvider>
        </ReactKeycloakProvider>
      </LanguageProvider>
    </ConfigProvider>
  );
};
